import React, {useContext} from 'react';
import PropTypes from 'prop-types';
import {useDrop} from "react-dnd";
import {TableBody} from "@material-ui/core";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import ScreenDesignerListHoc from "../../../../../../../../../HocHelpers/ScreenDesignerListHoc";
import {AcceptTypes} from "../../../../ToolBar/ToolBarUtils/ItemTypes";
import {ScreenDesignerContextNew} from "../../../../../../../../../ContextComponents/ScreenDesignerContextNew";
import RenderComponents from "../../RenderByType/RenderComponents";
import {primaryDropColor} from "../../../ScreenBar";
import Checkbox from "@material-ui/core/Checkbox/Checkbox";
import {generateUid} from "../../../../utils/lib";

const TableBodyList = ({columns, updateListSchema, id, gridProps: {selectable}}) => {
    return (
        <TableBody>
            <TableRow>
                {selectable && (
                    <RowCheckBox/>
                )}
                {columns.map((column, index) => (
                    !column.hidden ? (
                        <TableCell key={index} style={{width: column.width ? column.width : 'auto'}}>
                            <DropCell
                                column={column}
                                columnIndex={index}
                                updateListSchema={updateListSchema}
                                listId={id}
                            />

                        </TableCell>
                    ) : <></>
                ))}
            </TableRow>
        </TableBody>
    )
};
export default ScreenDesignerListHoc(TableBodyList);

TableBodyList.propTypes = {
    columns: PropTypes.array
};

TableBodyList.defaultProps = {
    columns: []
};


const DropCell = ({listId, column, columnIndex, updateListSchema}) => {
    const {presentation = []} = column;
    const {onSelectComponent, onMoveComponent} = useContext(ScreenDesignerContextNew);
    const [{isOverCurrent, canDrop}, drop] = useDrop({
        accept: AcceptTypes.listToolBar,
        collect: monitor => ({
            isOverCurrent: monitor.isOver({shallow: true}),
            canDrop: monitor.canDrop()
        }),
        drop: (item, monitor) => {
            const didDrop = monitor.didDrop();
            if (didDrop) {
                return;
            }
            if (item.dragType === 'move') {
                const currentPath = `listObject.${listId}.schema.columns.${columnIndex}.presentation.a`;
                onMoveComponent(
                    item.component,
                    item.from,
                    currentPath, //`${path}.children.${panelIndex}.children`,
                    presentation.length,
                    item.index,
                    presentation.length
                );
                return
            }
            //onDropComponent(item, 0, `${path}.children.${panelIndex}.children`)
            console.log('update list schema')
            updateListSchema(`columns.${columnIndex}.presentation`, {id: generateUid(item), ...item}, presentation.length)
        }
    });

    return (
        <div
            ref={drop}
            style={{
                width: '100%',
                minHeight: 30,
                display: 'flex',
                border: `1px dashed ${isOverCurrent && canDrop ? primaryDropColor : "#ebebeb"}`,
                alignItems: 'center'
            }}
            onClick={() => onSelectComponent(presentation, `listObject.${listId}.schema.columns.${columnIndex}.presentation`)}
        >

            {Array.isArray(presentation) ? (presentation || []).map((item, itemIndex) => {
                return item.type ? (
                    <RenderComponents
                        path={`listObject.${listId}.schema.columns.${columnIndex}.presentation.${itemIndex}`}
                        type={item.type}
                        parentPath={`listObject.${listId}.schema.columns.${columnIndex}.presentation`}
                        index={itemIndex}
                        item={item}
                        parentLength={presentation.length}
                        acceptType={'listToolBar'}
                        renderDirection={'row'}
                    />
                ) : <></>
            }) : <></>}
        </div>
    )
};

const RowCheckBox = () => {
    return (
        <TableCell
            style={{
                whiteSpace: 'nowrap',
                overflow: 'hidden'
            }}
            padding="checkbox"
        >
            <Checkbox
                style={{padding: 0}}
                color={"primary"}
                disabled
            />
        </TableCell>
    )
};